import { BadgeProps } from '@cox/core-ui8/dist/Badge'

export enum BadgeVariation {
  special = 'special',
  standard = 'standard',
  mobile = 'cox-mobl',
  fiber = 'cox-fiber',
  community = 'community',
  //Below colors are applicable for dynamic offer variables from webAPI
  green = 'cox-mobl',
  aqua = 'standard',
  teal = 'cox-fiber',
  merigold = 'special'
}

export interface ReactBadgeProps extends BadgeProps {
  contentBadgeText: string
  contentBadgeColor: keyof typeof BadgeVariation
  tokenProperties?: string
  isInEditor?: boolean
  isInContainer?: boolean
  /**jsonUrl should be the aem model.json url of expereience fragments or a page used only in storybook */
  jsonUrl?: string
}
